const fragment = `
precision highp float;

uniform vec3 uResolution;
uniform mat3 uCameraTextureMatrix;
uniform sampler2D uCameraTexture;
uniform float uBrightness;


void main()	{
  vec3 uv = gl_FragCoord.xyz / uResolution;
  uv = vec3(uv.xy, 1.0);
  uv = uCameraTextureMatrix * uv;

  vec3 c = texture2D(uCameraTexture, uv.xy).rgb;

  gl_FragColor = vec4(c, 1.0);
}
`

export default fragment
